import IdleJs from 'idle-js';

export function setupIdleJS() {
  function logout() {
    window.localStorage.removeItem('lastActive');
    popsss.post('/logout').done(() => popsss.follow('/login?was_idle=true'));
  }

  const IDLE_TIMEOUT =
    1000 * 60 * window.__CONFIG__.site.inactive_timeout_minutes;

  if (IDLE_TIMEOUT === 0) {
    return;
  }

  const idle = new IdleJs({
    idle: IDLE_TIMEOUT,
    onIdle: () => {
      logout();
    },
  });

  function lastActiveDate() {
    return (
      window.localStorage.lastActive ?? new Date(window.localStorage.lastActive)
    );
  }

  //Only track if the user is logged in
  if (window.__CONFIG__.user_id) {
    if (
      lastActiveDate() &&
      lastActiveDate() > new Date(Date.now() - IDLE_TIMEOUT)
    ) {
      logout();
    } else {
      window.localStorage.lastActive = new Date().toISOString();

      // Update the last active anytime the user does something
      ['mousemove', 'scroll', 'keydown', 'mousedown', 'touchstart'].forEach(
        (event) => {
          window.addEventListener(event, () => {
            if (lastActiveDate() && lastActiveDate() < new Date()) {
              window.localStorage.lastActive = new Date().toISOString();
            }
          });
        },
      );

      idle.start();
    }
  }
}
